module.exports = __webpack_public_path__ + "img/antes_despues_117.9c94ed58.png";